import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';

const thumbSize = 18;

const rules = ({ theme, left }) => ({
  background: theme.color.light,
  borderRadius: '50%',
  left: '8px',
  position: 'absolute',
  top: '6px',
  width: thumbSize,
  height: thumbSize,
  transform: `translateX(${left}px)`,
  ':hover': {
    opacity: '1',
  },
});

const Thumb = ({ left }) => {
  const { css } = useFela({ left });

  return (
    <div className={css(rules)} />
  );
};

Thumb.propTypes = {
  left: PropTypes.number,
};

export default React.memo(Thumb);
